import type { RouteRecordRaw } from 'vue-router'

export const tenderRoutes: RouteRecordRaw[] = [
  {
    path: '/tenders',
    name: 'tenders',
    component: () => import('@/modules/post-mvp/tender/views/TendersView.vue'),
    meta: {
      title: 'Тендеры',
      requiresAuth: true,
      requiresFeature: 'tender_enabled',
    },
  },
  {
    path: '/tenders/create',
    name: 'tender-create',
    component: () => import('@/modules/post-mvp/tender/views/CreateTenderView.vue'),
    meta: {
      title: 'Создание тендера',
      requiresAuth: true,
      requiresFeature: 'tender_enabled',
    },
  },
  {
    path: '/tenders/:id',
    name: 'tender-details',
    component: () => import('@/modules/post-mvp/tender/views/TenderDetailsView.vue'),
    meta: {
      title: 'Детали тендера',
      requiresAuth: true,
      requiresFeature: 'tender_enabled',
    },
    props: true,
  },
  {
    path: '/tenders/:id/applications',
    name: 'tender-applications',
    component: () => import('@/modules/post-mvp/tender/views/ApplicationListView.vue'),
    meta: {
      title: 'Заявки на тендер',
      requiresAuth: true,
      requiresFeature: 'tender_extended_enabled',
    },
    props: true,
  },
  {
    path: '/tenders/:tenderId/applications/create',
    name: 'application-create',
    component: () => import('@/modules/post-mvp/tender/views/ApplicationFormView.vue'),
    meta: {
      title: 'Подача заявки',
      requiresAuth: true,
      requiresFeature: 'tender_extended_enabled',
    },
    props: true,
  },
  {
    path: '/tenders/:id/evaluation',
    name: 'tender-evaluation',
    component: () => import('@/modules/post-mvp/tender/views/EvaluationView.vue'),
    meta: {
      title: 'Оценка тендера',
      requiresAuth: true,
      requiresFeature: 'tender_extended_enabled',
    },
    props: true,
  },
  {
    path: '/tenders/:id/results',
    name: 'tender-results',
    component: () => import('@/modules/post-mvp/tender/views/TenderResultsView.vue'),
    meta: {
      title: 'Результаты тендера',
      requiresAuth: true,
      requiresFeature: 'tender_extended_enabled',
    },
    props: true,
  },
  {
    path: '/applications/:applicationId',
    name: 'application-details',
    component: () => import('@/modules/post-mvp/tender/views/ApplicationDetailsView.vue'),
    meta: {
      title: 'Детали заявки',
      requiresAuth: true,
      requiresFeature: 'tender_extended_enabled',
    },
    props: true,
  },
  {
    path: '/applications/:applicationId/edit',
    name: 'application-edit',
    component: () => import('@/modules/post-mvp/tender/views/ApplicationFormView.vue'),
    meta: {
      title: 'Редактирование заявки',
      requiresAuth: true,
      requiresFeature: 'tender_extended_enabled',
    },
    props: true,
  },
  {
    path: '/tender-analytics',
    name: 'tender-analytics',
    component: () => import('@/modules/post-mvp/tender/views/TenderAnalyticsView.vue'),
    meta: {
      title: 'Аналитика тендеров',
      requiresAuth: true,
      requiresFeature: 'tender_extended_enabled',
    },
  },
]

export function createTenderRoutes() {
  return tenderRoutes
}
